import { api } from '@rd-web-markets/shared/dist/services/service';
import { useCallback } from 'react';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';

const searchV2Service = {
  useSearch: (setLoading, query) => {
    const [results, setResults, fetchResults] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!query) return { companies: [], claim_groups: [] };
        const response = await api.get(`/search?query=${encodeURIComponent(query)}`);
        return response;
      }, [query]),
      setLoading,
      initialStateValue: { companies: [], claim_groups: [] }
    });

    return [results, setResults, fetchResults];
  }
};

export default searchV2Service;
